<template>
  <div>    
    <SGPModalComponent
      v-model="abrirModal"
      tamanho="lg"
      titulo="Atualização"
      @sgpModalFechar="fecharModal"
      :mostrarFooter="false"
    >
    <SGPRowComponent>
      <SGPColComponent cols="5">
        <SGPFormSelectComponent
          name="ctrl_tratativa_id"
          v-model="formulario.ctrl_tratativa_id"
          placeholder="Tratativas Sem Tratamento"
          :listaDeOptions="listaDeTratativasSemTratamento"
          optionValue="id"
          optionLabel="tratativa"
          @input="recuperarTratativa"
        />
      </SGPColComponent>

      <SGPColComponent cols="4" v-if="tratativasOpcoes.length">
        <SGPFormSelectComponent
          name="ctrl_tratativa_opcao_id"
          v-model="formulario.ctrl_tratativa_opcao_id"
          placeholder="Opções da tratativa"
          :listaDeOptions="tratativasOpcoes"
          optionValue="id"
          optionLabel="opcao"
          @input="verificarOpcaoTratativa"
        />
      </SGPColComponent>

      <SGPColComponent cols="3">
        <SGPFormCheckboxComponent
          v-model="formulario.replica_bloco"
          label="Replicar no bloco"
          left
          hide-details
          :multiple="false"
          true-value="1"
          false-value="0"
          color="primary"
          class="manter-bloco no-padding no-margin"
          v-if="formulario.ctrl_tratativa_id == 14"
        ></SGPFormCheckboxComponent>
      </SGPColComponent>
      
      <SGPColComponent
        v-if="!formularioDinamico && !abrirModal && formulario.ctrl_tratativa_id"
      >
        <SGPFormBotaoComponent
          dark
          color="primary"
          class="mr-2"
          @click="dadosFormulario"
        >
          Salvar
        </SGPFormBotaoComponent>
      </SGPColComponent>
    </SGPRowComponent>

      <RenderizaFormularioComponent 
        v-if="formularioDinamico"
        :key="formularioDinamico"
        :arrayFormId="[{ ctrl_formulario_dinamico_id: formularioDinamico }]"
        :exportarDados="true"
        class="mt-4"
        @dadosFormularioDinamicoEmit="dadosFormulario"
      />

    </SGPModalComponent>

  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import RenderizacaoFormularioDinamicoComponent from '@/modules/workflow/forms/ctrl-formularios-dinamicos/components/RenderizacaoFormularioDinamicoComponent/RenderizacaoFormularioDinamicoComponent.vue'
import criarToast from '@/common/boot/ToastsHandler'

export default {
  name: "TratativasSemTratamentoComponent",
  components: {
    RenderizaFormularioComponent: RenderizacaoFormularioDinamicoComponent
  },

  props: {
    pco_tarefa_id: {
      type: Array,
      required: true
    },

    pco_circuito: {
      type: [Boolean, Object],
      required: false,
      default: false
    },

    emitSubmit: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  emit: [
    'tratativaAtualizacaoPayloadEmit'
  ],

  data () {
    return {
      abrirModal: true,
      tratativasOpcoes: [],
      formularioDinamico: '',
      formulario: {        
        ctrl_tratativa_id: '',
        ctrl_tratativa_opcao_id: '',
        replica_bloco: '1'
      },
    }
  },

  computed: {
    ...mapGetters('ctrlTratativas', [
      'listaDeTratativasSemTratamento'
    ]),

    ...mapGetters('fichaTecnicaWorkflow',[
      'fichaTecnicaHttpStatusCode'
    ])
  },

  methods: {
    ...mapActions('fichaTecnicaWorkflow', [
      'concluirSemIniciarTratamento',
      'buscarDadosFichaTecnica',
      'atualizaSolicitacaoCancelamento',
      'atualizaAvisoDeMulta',
      'buscarDadosHistoricoFichaTecnica'
    ]),
    
    recuperarTratativa(val) {
      this.listaDeTratativasSemTratamento.forEach(tratativa => {
        if(tratativa.id === val) {
          this.tratativasOpcoes = tratativa.ctrl_opcoes_tratativa
        }
      })
    },

    verificarOpcaoTratativa (val) {
      this.tratativasOpcoes.forEach(opcao => {
        if (opcao.id === val) {
          this.abrirModal = true
          this.formularioDinamico = opcao.ctrl_formulario_id
        }
      })
    },

    async dadosFormulario(form = null) {

      if (!this.formulario.ctrl_tratativa_opcao_id) {
        criarToast({
          tipo: 'error',
          mensagem: 'Escolha uma das opções das tratativas.'
        })
        return
      }

      const payload = {
        pco_tarefa_id: this.pco_tarefa_id,
        ctrl_tratativa_id: this.formulario.ctrl_tratativa_id,
        ctrl_tratativa_opcao_id: this.formulario.ctrl_tratativa_opcao_id,
        replica_bloco: this.formulario.replica_bloco ? parseInt(this.formulario.replica_bloco) : 0,
        dados: form ? JSON.stringify(form.values) : '',
        dados_por_form: form ? JSON.stringify(form.dadosPorformularios, function(k, v) { return v === undefined ? '' : v; }) : null,
        configuracao: form ? JSON.stringify(form.formularios) : '',
      }

      const tratativaAtualizacaoCordenacaoAvisoMulta = 21
      if (tratativaAtualizacaoCordenacaoAvisoMulta == payload.ctrl_tratativa_opcao_id) {
        await this.requisicaoAvisoMulta(payload)
        return
      }

      const tratativasCancelamento = {
        SOLICITACAO_CANCELAMENTO: 15,
        REMOVER_SOLICITACAO_CANCELAMENTO: 16
      }
      const trataivasCancelamentoEnum = [
        tratativasCancelamento.SOLICITACAO_CANCELAMENTO,
        tratativasCancelamento.REMOVER_SOLICITACAO_CANCELAMENTO
      ]

      // caso emitSubmit seja verdadeiro ele emite o payload para comoponente pai
      // E finaliza a operação
      if (trataivasCancelamentoEnum.includes(payload.ctrl_tratativa_id)) {
        this.requisicaoTratativasCancelamento(payload)
        return        
      }
   
      this.concluirSemIniciarTratamento(payload);

      setTimeout(async () => {
        this.fecharModal();
        await this.buscarDadosFichaTecnica(this.pco_tarefa_id);
      }, 10000)
      
      // busca dados do histórico
      // somente se o pco circuito existir
      // garantindo com isso a busca somente na tela de ficha tecnica
      if (this.pco_circuito) {
        setTimeout(() => {
          this.refazerBuscaPorDadosDoHistoricoNaFichaTecnica();
        }, 10000)
      }
    },

    async refazerBuscaPorDadosDoHistoricoNaFichaTecnica() {
      const filtrosHistorico = {
        pco_tarefa_id: [parseInt(this.pco_tarefa_id)],
        pco_circuito_id: this.pco_circuito.id,
        exibir_historico_completo: false,
      }
      await this.buscarDadosHistoricoFichaTecnica(filtrosHistorico)
    },

    async requisicaoTratativasCancelamento (payload) {
      if(typeof payload.pco_tarefa_id === 'number') {
          payload.pco_tarefa_id = [payload.pco_tarefa_id]
        }

        await this.atualizaSolicitacaoCancelamento(payload)
        this.refazerBuscaPorDadosDoHistoricoNaFichaTecnica();
        this.$emit('tratativaAtualizacaoPayloadEmit', payload)
        return 
    },

    async requisicaoAvisoMulta (payload) {
      if(typeof payload.pco_tarefa_id === 'number') {
          payload.pco_tarefa_id = [payload.pco_tarefa_id]
        }

        await this.atualizaAvisoDeMulta(payload)
        this.refazerBuscaPorDadosDoHistoricoNaFichaTecnica();
        this.$emit('tratativaAtualizacaoPayloadEmit', payload)
        return 
    },

    fecharModal () {
      this.abrirModal = false
      this.formularioDinamico = ''
      this.formulario = {}
      this.tratativasOpcoes = []
      this.$emit("fecharModalAtualizacao")
    }
  },

  watch: {
    fichaTecnicaHttpStatusCode: {
      deep: true,
      handler (val) {
        if (val === 200) {
          this.fecharModal()
        }
      }
    }
  }
}

</script>